/**
 * Запрашивает разрешение на Browser Notification у пользователя.
 * @returns текущий или обновлённый статус разрешения
 */
export const requestNotificationPermission =
  async (): Promise<NotificationPermission> => {
    if (typeof Notification === 'undefined') {
      return 'denied'
    }

    if (Notification.permission === 'granted') {
      return 'granted'
    }

    if (Notification.permission === 'denied') {
      return 'denied'
    }

    return Notification.requestPermission()
  }

/**
 * Показывает системное уведомление о новом заказе (только при granted).
 * @param params.orderId — номер заказа
 * @param params.totalPrice — сумма заказа в рублях
 * @param params.onClick — колбэк при клике по уведомлению
 */
export const showNewOrderNotification = (params: {
  orderId: number
  totalPrice: number
  onClick?: () => void
}): void => {
  if (typeof Notification === 'undefined') {
    return
  }

  if (Notification.permission !== 'granted') {
    return
  }

  const { orderId, totalPrice, onClick } = params

  // Сумму не показываем, если она неизвестна или некорректна (poll без цены)
  const notificationBody =
    totalPrice > 0 ? `Сумма ${totalPrice} ₽` : undefined

  const notification = new Notification(`Новый заказ №${orderId}`, {
    ...(notificationBody != null ? { body: notificationBody } : {}),
    tag: `order-${orderId}`,
  })

  notification.onclick = () => {
    window.focus()
    onClick?.()
    notification.close()
  }
}
